import type { ComponentType } from 'react';
import type { LottieProps } from 'react-lottie';
import LottieImport from 'react-lottie';

type LottieComponent = ComponentType<LottieProps>;

/** Unwrap nested CJS default exports from Vite ESM interop. */
function resolveLottieComponent(mod: unknown): LottieComponent {
  if (typeof mod === 'function') {
    return mod as LottieComponent;
  }
  if (mod && typeof mod === 'object' && 'default' in mod) {
    return resolveLottieComponent((mod as { default: unknown }).default);
  }
  throw new Error('Failed to resolve react-lottie component');
}

const Lottie = resolveLottieComponent(LottieImport);

export default Lottie;
